import { render, staticRenderFns } from "./ArceWizard.vue?vue&type=template&id=8a61ab5a&scoped=true&"
import script from "./ArceWizard.vue?vue&type=script&lang=js&"
export * from "./ArceWizard.vue?vue&type=script&lang=js&"
import style0 from "./ArceWizard.vue?vue&type=style&index=0&id=8a61ab5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a61ab5a",
  null
  
)

export default component.exports